import { jsxs as z, jsx as c, Fragment as Pe } from "react/jsx-runtime";
import * as Rt from "react";
import Ce, { createContext as Mt, forwardRef as it, createElement as pe, useContext as lt, useRef as H, useLayoutEffect as At, useImperativeHandle as st, useState as ie, useEffect as te, useCallback as j, useMemo as $t } from "react";
function ct(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = ct(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Ht() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = ct(e)) && (r && (r += " "), r += t);
  return r;
}
function m(...e) {
  return Ht(e);
}
const Gt = Ce.forwardRef(
  ({
    className: e,
    variant: t = "engage",
    size: n = "md",
    loading: r = !1,
    fullWidth: a = !1,
    disabled: o,
    children: i,
    ...l
  }, s) => {
    const f = o || r;
    return /* @__PURE__ */ z(
      "button",
      {
        ref: s,
        disabled: f,
        className: m(
          // Base styles
          "holo-button",
          "relative inline-flex items-center justify-center gap-2",
          "font-semibold tracking-wider uppercase",
          "transition-all duration-300 ease-out",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--holo-accent-cyan)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--holo-bg-deep)]",
          // Size variants
          {
            "px-3 py-1.5 text-xs": n === "sm",
            "px-6 py-3 text-sm": n === "md",
            "px-8 py-4 text-base": n === "lg"
          },
          // Style variants
          {
            // Engage (Primary)
            "bg-gradient-to-br from-[rgba(0,212,255,0.2)] to-[rgba(123,104,238,0.2)] border border-[var(--holo-accent-cyan)] text-[var(--holo-accent-cyan)] rounded-lg hover:from-[rgba(0,212,255,0.3)] hover:to-[rgba(123,104,238,0.3)] hover:shadow-[var(--holo-glow-strong)] hover:-translate-y-0.5 active:translate-y-0": t === "engage" && !f,
            // Secondary
            "bg-transparent border border-[var(--holo-border)] text-[var(--holo-text-secondary)] rounded-lg hover:border-[var(--holo-border-bright)] hover:text-[var(--holo-text-primary)] hover:bg-[rgba(0,212,255,0.05)]": t === "secondary" && !f,
            // Ghost
            "bg-transparent border-none text-[var(--holo-text-secondary)] rounded-lg hover:text-[var(--holo-text-primary)] hover:bg-[var(--holo-bg-surface-hover)]": t === "ghost" && !f,
            // Link
            "bg-transparent border-none text-[var(--holo-accent-cyan)] p-0 hover:text-[var(--holo-accent-cyan-dim)] underline-offset-4 hover:underline": t === "link" && !f
          },
          // Disabled state
          {
            "opacity-50 cursor-not-allowed hover:transform-none hover:shadow-none": f
          },
          // Full width
          {
            "w-full": a
          },
          e
        ),
        ...l,
        children: [
          t === "engage" && !f && /* @__PURE__ */ c("span", { className: "absolute inset-0 overflow-hidden rounded-lg pointer-events-none", children: /* @__PURE__ */ c("span", { className: "absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-[rgba(0,212,255,0.2)] to-transparent transition-transform duration-500 group-hover:translate-x-full" }) }),
          r ? /* @__PURE__ */ z(Pe, { children: [
            /* @__PURE__ */ c("span", { className: "w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" }),
            /* @__PURE__ */ c("span", { children: "Processing..." })
          ] }) : i
        ]
      }
    );
  }
);
Gt.displayName = "Button";
const Tt = Ce.forwardRef(
  ({ className: e, label: t, error: n, hint: r, id: a, ...o }, i) => {
    const l = a || `holo-input-${Ce.useId()}`;
    return /* @__PURE__ */ z("div", { className: "holo-input-wrapper flex flex-col gap-2", children: [
      t && /* @__PURE__ */ c(
        "label",
        {
          htmlFor: l,
          className: m(
            "text-[11px] font-semibold tracking-[1.5px] uppercase",
            "text-[var(--holo-text-secondary)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ c(
        "input",
        {
          ref: i,
          id: l,
          className: m(
            "holo-input",
            "w-full px-4 py-3.5",
            "bg-[rgba(0,20,40,0.6)]",
            "border rounded-lg",
            "text-[var(--holo-text-primary)] text-sm",
            "placeholder:text-[var(--holo-text-muted)]",
            "transition-all duration-300",
            // Default border
            "border-[var(--holo-border)]",
            // Hover state
            "hover:border-[rgba(0,180,216,0.5)]",
            // Focus state
            "focus:outline-none focus:border-[var(--holo-accent-cyan)]",
            "focus:shadow-[var(--holo-glow),inset_0_0_20px_rgba(0,212,255,0.05)]",
            // Error state
            {
              "border-[var(--holo-accent-red)] focus:border-[var(--holo-accent-red)] focus:shadow-[0_0_20px_rgba(255,75,75,0.3)]": n
            },
            // Disabled state
            "disabled:opacity-50 disabled:cursor-not-allowed",
            e
          ),
          ...o
        }
      ),
      (n || r) && /* @__PURE__ */ c(
        "span",
        {
          className: m(
            "text-xs",
            n ? "text-[var(--holo-accent-red)]" : "text-[var(--holo-text-muted)]"
          ),
          children: n || r
        }
      )
    ] });
  }
);
Tt.displayName = "Input";
const Wt = Ce.forwardRef(
  ({
    className: e,
    brackets: t = !1,
    variant: n = "default",
    glow: r = !1,
    header: a,
    children: o,
    ...i
  }, l) => /* @__PURE__ */ z(
    "div",
    {
      ref: l,
      className: m(
        "holo-panel",
        "relative rounded-xl",
        "backdrop-blur-md",
        // Variant styles
        {
          // Default
          "bg-[var(--holo-bg-panel)] border border-[var(--holo-border)]": n === "default",
          // Elevated (more prominent)
          "bg-[var(--holo-bg-panel-light)] border border-[var(--holo-border-bright)] shadow-[var(--holo-shadow-panel)]": n === "elevated",
          // Transmission (message bubble style)
          "bg-gradient-to-br from-[rgba(0,212,255,0.12)] to-[rgba(0,212,255,0.04)] border border-[rgba(0,212,255,0.3)]": n === "transmission"
        },
        // Glow effect
        {
          "shadow-[var(--holo-glow)]": r
        },
        e
      ),
      ...i,
      children: [
        t && /* @__PURE__ */ z(Pe, { children: [
          /* @__PURE__ */ c("span", { className: "absolute top-1 left-1 w-3 h-3 border-t-2 border-l-2 border-[var(--holo-accent-cyan)] opacity-60" }),
          /* @__PURE__ */ c("span", { className: "absolute top-1 right-1 w-3 h-3 border-t-2 border-r-2 border-[var(--holo-accent-cyan)] opacity-60" }),
          /* @__PURE__ */ c("span", { className: "absolute bottom-1 left-1 w-3 h-3 border-b-2 border-l-2 border-[var(--holo-accent-cyan)] opacity-60" }),
          /* @__PURE__ */ c("span", { className: "absolute bottom-1 right-1 w-3 h-3 border-b-2 border-r-2 border-[var(--holo-accent-cyan)] opacity-60" })
        ] }),
        a && /* @__PURE__ */ c("div", { className: "px-4 py-3 border-b border-[var(--holo-border)]", children: a }),
        o
      ]
    }
  )
);
Wt.displayName = "Panel";
const Ot = ({
  title: e,
  lines: t = !1,
  className: n,
  children: r,
  ...a
}) => /* @__PURE__ */ z(
  "div",
  {
    className: m(
      "holo-panel-header",
      "flex items-center gap-4",
      n
    ),
    ...a,
    children: [
      t && /* @__PURE__ */ c("span", { className: "flex-1 h-0.5 bg-gradient-to-r from-[var(--holo-accent-cyan)] to-transparent rounded" }),
      /* @__PURE__ */ c("span", { className: "text-xs font-bold tracking-[3px] uppercase text-[var(--holo-accent-cyan)] whitespace-nowrap", children: e }),
      t && /* @__PURE__ */ c("span", { className: "flex-1 h-0.5 bg-gradient-to-l from-[var(--holo-accent-cyan)] to-transparent rounded" }),
      r
    ]
  }
);
Ot.displayName = "PanelHeader";
const jt = ({
  variant: e = "default",
  size: t = "md",
  pulse: n = !1,
  className: r,
  children: a,
  ...o
}) => /* @__PURE__ */ c(
  "span",
  {
    className: m(
      "holo-badge",
      "inline-flex items-center gap-1.5",
      "font-bold tracking-[1.5px] uppercase",
      "rounded",
      // Size variants
      {
        "px-2 py-0.5 text-[9px]": t === "sm",
        "px-2.5 py-1 text-[10px]": t === "md"
      },
      // Color variants
      {
        // Default / Info / Officer (cyan)
        "bg-[rgba(0,212,255,0.15)] text-[var(--holo-accent-cyan)] border border-[rgba(0,212,255,0.3)]": e === "default" || e === "info" || e === "officer",
        // Captain (purple)
        "bg-[rgba(123,104,238,0.2)] text-[#a78bfa] border border-[rgba(123,104,238,0.4)]": e === "captain",
        // Success (green)
        "bg-[rgba(0,255,136,0.15)] text-[var(--holo-accent-green)] border border-[rgba(0,255,136,0.3)]": e === "success",
        // Warning (amber)
        "bg-[rgba(255,179,71,0.15)] text-[var(--holo-accent-amber)] border border-[rgba(255,179,71,0.3)]": e === "warning",
        // Error (red)
        "bg-[rgba(255,75,75,0.15)] text-[var(--holo-accent-red)] border border-[rgba(255,75,75,0.3)]": e === "error"
      },
      // Pulse animation
      {
        "animate-pulse": n
      },
      r
    ),
    ...o,
    children: a
  }
);
jt.displayName = "Badge";
const dt = ({
  status: e,
  size: t = "md",
  className: n,
  ...r
}) => /* @__PURE__ */ c(
  "span",
  {
    className: m(
      "holo-status-light",
      "inline-block rounded-full",
      // Size
      {
        "w-1.5 h-1.5": t === "sm",
        "w-2 h-2": t === "md"
      },
      // Status colors and animations
      {
        "bg-[var(--holo-accent-green)] shadow-[0_0_8px_var(--holo-accent-green)] animate-[holo-status-blink_2s_ease-in-out_infinite]": e === "online",
        "bg-[var(--holo-accent-red)] shadow-[0_0_8px_var(--holo-accent-red)]": e === "offline",
        "bg-[var(--holo-accent-amber)] shadow-[0_0_8px_var(--holo-accent-amber)] animate-[holo-status-pulse_1s_ease-in-out_infinite]": e === "processing",
        "bg-[var(--holo-text-muted)]": e === "idle"
      },
      n
    ),
    ...r
  }
);
dt.displayName = "StatusLight";
const Ut = ({
  title: e,
  subtitle: t,
  logo: n,
  status: r = "online",
  statusText: a,
  actions: o,
  className: i,
  ...l
}) => {
  const s = {
    online: "ONLINE",
    offline: "OFFLINE",
    processing: "PROCESSING"
  };
  return /* @__PURE__ */ z(
    "header",
    {
      className: m(
        "holo-command-bar",
        "relative flex items-center justify-between",
        "h-14 px-4",
        "bg-gradient-to-b from-[rgba(10,15,30,0.95)] to-[rgba(10,15,30,0.85)]",
        "border-b border-[var(--holo-border)]",
        "shadow-[0_4px_20px_rgba(0,0,0,0.3),inset_0_-1px_0_rgba(0,212,255,0.1)]",
        i
      ),
      ...l,
      children: [
        /* @__PURE__ */ c("div", { className: "absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[rgba(0,212,255,0.4)] to-transparent" }),
        /* @__PURE__ */ z("div", { className: "flex items-center gap-3", children: [
          n,
          /* @__PURE__ */ c("div", { className: "flex flex-col", children: /* @__PURE__ */ z("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ c("span", { className: "text-sm font-bold tracking-[2px] uppercase text-[var(--holo-text-primary)]", children: e }),
            t && /* @__PURE__ */ z(Pe, { children: [
              /* @__PURE__ */ c("span", { className: "text-[var(--holo-text-muted)]", children: "|" }),
              /* @__PURE__ */ c("span", { className: "text-xs font-medium tracking-wider uppercase text-[var(--holo-accent-cyan)]", children: t })
            ] })
          ] }) }),
          /* @__PURE__ */ z("div", { className: "flex items-center gap-2 ml-4 px-3 py-1 rounded-full bg-[rgba(0,0,0,0.3)]", children: [
            /* @__PURE__ */ c(dt, { status: r }),
            /* @__PURE__ */ c("span", { className: "text-[10px] font-semibold tracking-wider uppercase text-[var(--holo-text-secondary)]", children: a || s[r] })
          ] })
        ] }),
        o && /* @__PURE__ */ c("div", { className: "flex items-center gap-2", children: o })
      ]
    }
  );
};
Ut.displayName = "CommandBar";
function ut(e = /* @__PURE__ */ new Date()) {
  const t = e.getFullYear(), n = new Date(t, 0, 1), r = new Date(t + 1, 0, 1), a = (e.getTime() - n.getTime()) / (r.getTime() - n.getTime()), o = 2024, i = 47e3, l = (t - o) * 1e3;
  return (i + l + a * 1e3).toFixed(1);
}
function Vt() {
  return ut(/* @__PURE__ */ new Date());
}
function Vn(e) {
  return `Stardate ${ut(e)}`;
}
function Kn(e = /* @__PURE__ */ new Date()) {
  return e.toLocaleTimeString("en-US", {
    hour12: !1,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
}
const Kt = ({
  items: e = [],
  showStardate: t = !0,
  left: n,
  right: r,
  className: a,
  ...o
}) => {
  const i = e.filter((s) => s.align !== "right"), l = e.filter((s) => s.align === "right");
  return /* @__PURE__ */ z(
    "footer",
    {
      className: m(
        "holo-status-bar",
        "flex items-center justify-between",
        "h-6 px-3",
        "bg-[var(--holo-bg-panel)]",
        "border-t border-[var(--holo-border)]",
        "text-[10px] font-medium tracking-wide",
        a
      ),
      ...o,
      children: [
        /* @__PURE__ */ z("div", { className: "flex items-center gap-3", children: [
          n,
          i.map((s) => /* @__PURE__ */ c($e, { children: s.content }, s.id))
        ] }),
        /* @__PURE__ */ z("div", { className: "flex items-center gap-3", children: [
          l.map((s) => /* @__PURE__ */ c($e, { children: s.content }, s.id)),
          r,
          t && /* @__PURE__ */ z($e, { children: [
            /* @__PURE__ */ c("span", { className: "text-[var(--holo-text-muted)]", children: "Stardate" }),
            /* @__PURE__ */ c("span", { className: "text-[var(--holo-accent-cyan)] font-mono ml-1", children: Vt() })
          ] })
        ] })
      ]
    }
  );
};
Kt.displayName = "StatusBar";
const $e = ({ children: e, className: t }) => /* @__PURE__ */ c(
  "div",
  {
    className: m(
      "flex items-center gap-1.5 px-2 py-0.5",
      "text-[var(--holo-text-secondary)]",
      "border-r border-[var(--holo-border)] last:border-r-0",
      t
    ),
    children: e
  }
), Be = Mt(null);
Be.displayName = "PanelGroupContext";
const L = {
  group: "data-panel-group",
  groupDirection: "data-panel-group-direction",
  groupId: "data-panel-group-id",
  panel: "data-panel",
  panelCollapsible: "data-panel-collapsible",
  panelId: "data-panel-id",
  panelSize: "data-panel-size",
  resizeHandle: "data-resize-handle",
  resizeHandleActive: "data-resize-handle-active",
  resizeHandleEnabled: "data-panel-resize-handle-enabled",
  resizeHandleId: "data-panel-resize-handle-id",
  resizeHandleState: "data-resize-handle-state"
}, Ue = 10, le = At, Ze = Rt.useId, qt = typeof Ze == "function" ? Ze : () => null;
let Xt = 0;
function Ve(e = null) {
  const t = qt(), n = H(e || t || null);
  return n.current === null && (n.current = "" + Xt++), e ?? n.current;
}
function ft({
  children: e,
  className: t = "",
  collapsedSize: n,
  collapsible: r,
  defaultSize: a,
  forwardedRef: o,
  id: i,
  maxSize: l,
  minSize: s,
  onCollapse: f,
  onExpand: N,
  onResize: g,
  order: u,
  style: h,
  tagName: d = "div",
  ...k
}) {
  const y = lt(Be);
  if (y === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    collapsePanel: F,
    expandPanel: E,
    getPanelSize: R,
    getPanelStyle: A,
    groupId: Y,
    isPanelCollapsed: P,
    reevaluatePanelConstraints: C,
    registerPanel: K,
    resizePanel: Q,
    unregisterPanel: U
  } = y, T = Ve(i), I = H({
    callbacks: {
      onCollapse: f,
      onExpand: N,
      onResize: g
    },
    constraints: {
      collapsedSize: n,
      collapsible: r,
      defaultSize: a,
      maxSize: l,
      minSize: s
    },
    id: T,
    idIsFromProps: i !== void 0,
    order: u
  });
  H({
    didLogMissingDefaultSizeWarning: !1
  }), le(() => {
    const {
      callbacks: G,
      constraints: $
    } = I.current, W = {
      ...$
    };
    I.current.id = T, I.current.idIsFromProps = i !== void 0, I.current.order = u, G.onCollapse = f, G.onExpand = N, G.onResize = g, $.collapsedSize = n, $.collapsible = r, $.defaultSize = a, $.maxSize = l, $.minSize = s, (W.collapsedSize !== $.collapsedSize || W.collapsible !== $.collapsible || W.maxSize !== $.maxSize || W.minSize !== $.minSize) && C(I.current, W);
  }), le(() => {
    const G = I.current;
    return K(G), () => {
      U(G);
    };
  }, [u, T, K, U]), st(o, () => ({
    collapse: () => {
      F(I.current);
    },
    expand: (G) => {
      E(I.current, G);
    },
    getId() {
      return T;
    },
    getSize() {
      return R(I.current);
    },
    isCollapsed() {
      return P(I.current);
    },
    isExpanded() {
      return !P(I.current);
    },
    resize: (G) => {
      Q(I.current, G);
    }
  }), [F, E, R, P, T, Q]);
  const re = A(I.current, a);
  return pe(d, {
    ...k,
    children: e,
    className: t,
    id: T,
    style: {
      ...re,
      ...h
    },
    // CSS selectors
    [L.groupId]: Y,
    [L.panel]: "",
    [L.panelCollapsible]: r || void 0,
    [L.panelId]: T,
    [L.panelSize]: parseFloat("" + re.flexGrow).toFixed(1)
  });
}
const gt = it((e, t) => pe(ft, {
  ...e,
  forwardedRef: t
}));
ft.displayName = "Panel";
gt.displayName = "forwardRef(Panel)";
let je = null, Ne = -1, ne = null;
function Yt(e, t) {
  if (t) {
    const n = (t & xt) !== 0, r = (t & vt) !== 0, a = (t & yt) !== 0, o = (t & Ft) !== 0;
    if (n)
      return a ? "se-resize" : o ? "ne-resize" : "e-resize";
    if (r)
      return a ? "sw-resize" : o ? "nw-resize" : "w-resize";
    if (a)
      return "s-resize";
    if (o)
      return "n-resize";
  }
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function Zt() {
  ne !== null && (document.head.removeChild(ne), je = null, ne = null, Ne = -1);
}
function He(e, t) {
  var n, r;
  const a = Yt(e, t);
  if (je !== a) {
    if (je = a, ne === null && (ne = document.createElement("style"), document.head.appendChild(ne)), Ne >= 0) {
      var o;
      (o = ne.sheet) === null || o === void 0 || o.removeRule(Ne);
    }
    Ne = (n = (r = ne.sheet) === null || r === void 0 ? void 0 : r.insertRule(`*{cursor: ${a} !important;}`)) !== null && n !== void 0 ? n : -1;
  }
}
function pt(e) {
  return e.type === "keydown";
}
function bt(e) {
  return e.type.startsWith("pointer");
}
function ht(e) {
  return e.type.startsWith("mouse");
}
function Le(e) {
  if (bt(e)) {
    if (e.isPrimary)
      return {
        x: e.clientX,
        y: e.clientY
      };
  } else if (ht(e))
    return {
      x: e.clientX,
      y: e.clientY
    };
  return {
    x: 1 / 0,
    y: 1 / 0
  };
}
function Jt() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
function Qt(e, t, n) {
  return e.x < t.x + t.width && e.x + e.width > t.x && e.y < t.y + t.height && e.y + e.height > t.y;
}
function en(e, t) {
  if (e === t) throw new Error("Cannot compare node with itself");
  const n = {
    a: et(e),
    b: et(t)
  };
  let r;
  for (; n.a.at(-1) === n.b.at(-1); )
    e = n.a.pop(), t = n.b.pop(), r = e;
  S(r, "Stacking order can only be calculated for elements with a common ancestor");
  const a = {
    a: Qe(Je(n.a)),
    b: Qe(Je(n.b))
  };
  if (a.a === a.b) {
    const o = r.childNodes, i = {
      a: n.a.at(-1),
      b: n.b.at(-1)
    };
    let l = o.length;
    for (; l--; ) {
      const s = o[l];
      if (s === i.a) return 1;
      if (s === i.b) return -1;
    }
  }
  return Math.sign(a.a - a.b);
}
const tn = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function nn(e) {
  var t;
  const n = getComputedStyle((t = mt(e)) !== null && t !== void 0 ? t : e).display;
  return n === "flex" || n === "inline-flex";
}
function rn(e) {
  const t = getComputedStyle(e);
  return !!(t.position === "fixed" || t.zIndex !== "auto" && (t.position !== "static" || nn(e)) || +t.opacity < 1 || "transform" in t && t.transform !== "none" || "webkitTransform" in t && t.webkitTransform !== "none" || "mixBlendMode" in t && t.mixBlendMode !== "normal" || "filter" in t && t.filter !== "none" || "webkitFilter" in t && t.webkitFilter !== "none" || "isolation" in t && t.isolation === "isolate" || tn.test(t.willChange) || t.webkitOverflowScrolling === "touch");
}
function Je(e) {
  let t = e.length;
  for (; t--; ) {
    const n = e[t];
    if (S(n, "Missing node"), rn(n)) return n;
  }
  return null;
}
function Qe(e) {
  return e && Number(getComputedStyle(e).zIndex) || 0;
}
function et(e) {
  const t = [];
  for (; e; )
    t.push(e), e = mt(e);
  return t;
}
function mt(e) {
  const {
    parentNode: t
  } = e;
  return t && t instanceof ShadowRoot ? t.host : t;
}
const xt = 1, vt = 2, yt = 4, Ft = 8, on = Jt() === "coarse";
let X = [], ge = !1, ae = /* @__PURE__ */ new Map(), Ie = /* @__PURE__ */ new Map();
const Se = /* @__PURE__ */ new Set();
function an(e, t, n, r, a) {
  var o;
  const {
    ownerDocument: i
  } = t, l = {
    direction: n,
    element: t,
    hitAreaMargins: r,
    setResizeHandlerState: a
  }, s = (o = ae.get(i)) !== null && o !== void 0 ? o : 0;
  return ae.set(i, s + 1), Se.add(l), Ee(), function() {
    var N;
    Ie.delete(e), Se.delete(l);
    const g = (N = ae.get(i)) !== null && N !== void 0 ? N : 1;
    if (ae.set(i, g - 1), Ee(), g === 1 && ae.delete(i), X.includes(l)) {
      const u = X.indexOf(l);
      u >= 0 && X.splice(u, 1), qe(), a("up", !0, null);
    }
  };
}
function ln(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: r
  } = Le(e);
  ge = !0, Ke({
    target: t,
    x: n,
    y: r
  }), Ee(), X.length > 0 && (De("down", e), e.preventDefault(), wt(t) || e.stopImmediatePropagation());
}
function Ge(e) {
  const {
    x: t,
    y: n
  } = Le(e);
  if (ge && e.buttons === 0 && (ge = !1, De("up", e)), !ge) {
    const {
      target: r
    } = e;
    Ke({
      target: r,
      x: t,
      y: n
    });
  }
  De("move", e), qe(), X.length > 0 && e.preventDefault();
}
function Te(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: r
  } = Le(e);
  Ie.clear(), ge = !1, X.length > 0 && (e.preventDefault(), wt(t) || e.stopImmediatePropagation()), De("up", e), Ke({
    target: t,
    x: n,
    y: r
  }), qe(), Ee();
}
function wt(e) {
  let t = e;
  for (; t; ) {
    if (t.hasAttribute(L.resizeHandle))
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function Ke({
  target: e,
  x: t,
  y: n
}) {
  X.splice(0);
  let r = null;
  (e instanceof HTMLElement || e instanceof SVGElement) && (r = e), Se.forEach((a) => {
    const {
      element: o,
      hitAreaMargins: i
    } = a, l = o.getBoundingClientRect(), {
      bottom: s,
      left: f,
      right: N,
      top: g
    } = l, u = on ? i.coarse : i.fine;
    if (t >= f - u && t <= N + u && n >= g - u && n <= s + u) {
      if (r !== null && document.contains(r) && o !== r && !o.contains(r) && !r.contains(o) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      en(r, o) > 0) {
        let d = r, k = !1;
        for (; d && !d.contains(o); ) {
          if (Qt(d.getBoundingClientRect(), l)) {
            k = !0;
            break;
          }
          d = d.parentElement;
        }
        if (k)
          return;
      }
      X.push(a);
    }
  });
}
function We(e, t) {
  Ie.set(e, t);
}
function qe() {
  let e = !1, t = !1;
  X.forEach((r) => {
    const {
      direction: a
    } = r;
    a === "horizontal" ? e = !0 : t = !0;
  });
  let n = 0;
  Ie.forEach((r) => {
    n |= r;
  }), e && t ? He("intersection", n) : e ? He("horizontal", n) : t ? He("vertical", n) : Zt();
}
let Oe = new AbortController();
function Ee() {
  Oe.abort(), Oe = new AbortController();
  const e = {
    capture: !0,
    signal: Oe.signal
  };
  Se.size && (ge ? (X.length > 0 && ae.forEach((t, n) => {
    const {
      body: r
    } = n;
    t > 0 && (r.addEventListener("contextmenu", Te, e), r.addEventListener("pointerleave", Ge, e), r.addEventListener("pointermove", Ge, e));
  }), window.addEventListener("pointerup", Te, e), window.addEventListener("pointercancel", Te, e)) : ae.forEach((t, n) => {
    const {
      body: r
    } = n;
    t > 0 && (r.addEventListener("pointerdown", ln, e), r.addEventListener("pointermove", Ge, e));
  }));
}
function De(e, t) {
  Se.forEach((n) => {
    const {
      setResizeHandlerState: r
    } = n, a = X.includes(n);
    r(e, a, t);
  });
}
function sn() {
  const [e, t] = ie(0);
  return j(() => t((n) => n + 1), []);
}
function S(e, t) {
  if (!e)
    throw console.error(t), Error(t);
}
function se(e, t, n = Ue) {
  return e.toFixed(n) === t.toFixed(n) ? 0 : e > t ? 1 : -1;
}
function ee(e, t, n = Ue) {
  return se(e, t, n) === 0;
}
function V(e, t, n) {
  return se(e, t, n) === 0;
}
function cn(e, t, n) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++) {
    const a = e[r], o = t[r];
    if (!V(a, o, n))
      return !1;
  }
  return !0;
}
function fe({
  panelConstraints: e,
  panelIndex: t,
  size: n
}) {
  const r = e[t];
  S(r != null, `Panel constraints not found for index ${t}`);
  let {
    collapsedSize: a = 0,
    collapsible: o,
    maxSize: i = 100,
    minSize: l = 0
  } = r;
  if (se(n, l) < 0)
    if (o) {
      const s = (a + l) / 2;
      se(n, s) < 0 ? n = a : n = l;
    } else
      n = l;
  return n = Math.min(i, n), n = parseFloat(n.toFixed(Ue)), n;
}
function Fe({
  delta: e,
  initialLayout: t,
  panelConstraints: n,
  pivotIndices: r,
  prevLayout: a,
  trigger: o
}) {
  if (V(e, 0))
    return t;
  const i = [...t], [l, s] = r;
  S(l != null, "Invalid first pivot index"), S(s != null, "Invalid second pivot index");
  let f = 0;
  if (o === "keyboard") {
    {
      const g = e < 0 ? s : l, u = n[g];
      S(u, `Panel constraints not found for index ${g}`);
      const {
        collapsedSize: h = 0,
        collapsible: d,
        minSize: k = 0
      } = u;
      if (d) {
        const y = t[g];
        if (S(y != null, `Previous layout not found for panel index ${g}`), V(y, h)) {
          const F = k - y;
          se(F, Math.abs(e)) > 0 && (e = e < 0 ? 0 - F : F);
        }
      }
    }
    {
      const g = e < 0 ? l : s, u = n[g];
      S(u, `No panel constraints found for index ${g}`);
      const {
        collapsedSize: h = 0,
        collapsible: d,
        minSize: k = 0
      } = u;
      if (d) {
        const y = t[g];
        if (S(y != null, `Previous layout not found for panel index ${g}`), V(y, k)) {
          const F = y - h;
          se(F, Math.abs(e)) > 0 && (e = e < 0 ? 0 - F : F);
        }
      }
    }
  }
  {
    const g = e < 0 ? 1 : -1;
    let u = e < 0 ? s : l, h = 0;
    for (; ; ) {
      const k = t[u];
      S(k != null, `Previous layout not found for panel index ${u}`);
      const F = fe({
        panelConstraints: n,
        panelIndex: u,
        size: 100
      }) - k;
      if (h += F, u += g, u < 0 || u >= n.length)
        break;
    }
    const d = Math.min(Math.abs(e), Math.abs(h));
    e = e < 0 ? 0 - d : d;
  }
  {
    let u = e < 0 ? l : s;
    for (; u >= 0 && u < n.length; ) {
      const h = Math.abs(e) - Math.abs(f), d = t[u];
      S(d != null, `Previous layout not found for panel index ${u}`);
      const k = d - h, y = fe({
        panelConstraints: n,
        panelIndex: u,
        size: k
      });
      if (!V(d, y) && (f += d - y, i[u] = y, f.toPrecision(3).localeCompare(Math.abs(e).toPrecision(3), void 0, {
        numeric: !0
      }) >= 0))
        break;
      e < 0 ? u-- : u++;
    }
  }
  if (cn(a, i))
    return a;
  {
    const g = e < 0 ? s : l, u = t[g];
    S(u != null, `Previous layout not found for panel index ${g}`);
    const h = u + f, d = fe({
      panelConstraints: n,
      panelIndex: g,
      size: h
    });
    if (i[g] = d, !V(d, h)) {
      let k = h - d, F = e < 0 ? s : l;
      for (; F >= 0 && F < n.length; ) {
        const E = i[F];
        S(E != null, `Previous layout not found for panel index ${F}`);
        const R = E + k, A = fe({
          panelConstraints: n,
          panelIndex: F,
          size: R
        });
        if (V(E, A) || (k -= A - E, i[F] = A), V(k, 0))
          break;
        e > 0 ? F-- : F++;
      }
    }
  }
  const N = i.reduce((g, u) => u + g, 0);
  return V(N, 100) ? i : a;
}
function dn({
  layout: e,
  panelsArray: t,
  pivotIndices: n
}) {
  let r = 0, a = 100, o = 0, i = 0;
  const l = n[0];
  S(l != null, "No pivot index found"), t.forEach((g, u) => {
    const {
      constraints: h
    } = g, {
      maxSize: d = 100,
      minSize: k = 0
    } = h;
    u === l ? (r = k, a = d) : (o += k, i += d);
  });
  const s = Math.min(a, 100 - o), f = Math.max(r, 100 - i), N = e[l];
  return {
    valueMax: s,
    valueMin: f,
    valueNow: N
  };
}
function ze(e, t = document) {
  return Array.from(t.querySelectorAll(`[${L.resizeHandleId}][data-panel-group-id="${e}"]`));
}
function St(e, t, n = document) {
  const a = ze(e, n).findIndex((o) => o.getAttribute(L.resizeHandleId) === t);
  return a ?? null;
}
function zt(e, t, n) {
  const r = St(e, t, n);
  return r != null ? [r, r + 1] : [-1, -1];
}
function kt(e, t = document) {
  var n;
  if (t instanceof HTMLElement && (t == null || (n = t.dataset) === null || n === void 0 ? void 0 : n.panelGroupId) == e)
    return t;
  const r = t.querySelector(`[data-panel-group][data-panel-group-id="${e}"]`);
  return r || null;
}
function Re(e, t = document) {
  const n = t.querySelector(`[${L.resizeHandleId}="${e}"]`);
  return n || null;
}
function un(e, t, n, r = document) {
  var a, o, i, l;
  const s = Re(t, r), f = ze(e, r), N = s ? f.indexOf(s) : -1, g = (a = (o = n[N]) === null || o === void 0 ? void 0 : o.id) !== null && a !== void 0 ? a : null, u = (i = (l = n[N + 1]) === null || l === void 0 ? void 0 : l.id) !== null && i !== void 0 ? i : null;
  return [g, u];
}
function fn({
  committedValuesRef: e,
  eagerValuesRef: t,
  groupId: n,
  layout: r,
  panelDataArray: a,
  panelGroupElement: o,
  setLayout: i
}) {
  H({
    didWarnAboutMissingResizeHandle: !1
  }), le(() => {
    if (!o)
      return;
    const l = ze(n, o);
    for (let s = 0; s < a.length - 1; s++) {
      const {
        valueMax: f,
        valueMin: N,
        valueNow: g
      } = dn({
        layout: r,
        panelsArray: a,
        pivotIndices: [s, s + 1]
      }), u = l[s];
      if (u != null) {
        const h = a[s];
        S(h, `No panel data found for index "${s}"`), u.setAttribute("aria-controls", h.id), u.setAttribute("aria-valuemax", "" + Math.round(f)), u.setAttribute("aria-valuemin", "" + Math.round(N)), u.setAttribute("aria-valuenow", g != null ? "" + Math.round(g) : "");
      }
    }
    return () => {
      l.forEach((s, f) => {
        s.removeAttribute("aria-controls"), s.removeAttribute("aria-valuemax"), s.removeAttribute("aria-valuemin"), s.removeAttribute("aria-valuenow");
      });
    };
  }, [n, r, a, o]), te(() => {
    if (!o)
      return;
    const l = t.current;
    S(l, "Eager values not found");
    const {
      panelDataArray: s
    } = l, f = kt(n, o);
    S(f != null, `No group found for id "${n}"`);
    const N = ze(n, o);
    S(N, `No resize handles found for group id "${n}"`);
    const g = N.map((u) => {
      const h = u.getAttribute(L.resizeHandleId);
      S(h, "Resize handle element has no handle id attribute");
      const [d, k] = un(n, h, s, o);
      if (d == null || k == null)
        return () => {
        };
      const y = (F) => {
        if (!F.defaultPrevented)
          switch (F.key) {
            case "Enter": {
              F.preventDefault();
              const E = s.findIndex((R) => R.id === d);
              if (E >= 0) {
                const R = s[E];
                S(R, `No panel data found for index ${E}`);
                const A = r[E], {
                  collapsedSize: Y = 0,
                  collapsible: P,
                  minSize: C = 0
                } = R.constraints;
                if (A != null && P) {
                  const K = Fe({
                    delta: V(A, Y) ? C - Y : Y - A,
                    initialLayout: r,
                    panelConstraints: s.map((Q) => Q.constraints),
                    pivotIndices: zt(n, h, o),
                    prevLayout: r,
                    trigger: "keyboard"
                  });
                  r !== K && i(K);
                }
              }
              break;
            }
          }
      };
      return u.addEventListener("keydown", y), () => {
        u.removeEventListener("keydown", y);
      };
    });
    return () => {
      g.forEach((u) => u());
    };
  }, [o, e, t, n, r, a, i]);
}
function tt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function _t(e, t) {
  const n = e === "horizontal", {
    x: r,
    y: a
  } = Le(t);
  return n ? r : a;
}
function gn(e, t, n, r, a) {
  const o = n === "horizontal", i = Re(t, a);
  S(i, `No resize handle element found for id "${t}"`);
  const l = i.getAttribute(L.groupId);
  S(l, "Resize handle element has no group id attribute");
  let {
    initialCursorPosition: s
  } = r;
  const f = _t(n, e), N = kt(l, a);
  S(N, `No group element found for id "${l}"`);
  const g = N.getBoundingClientRect(), u = o ? g.width : g.height;
  return (f - s) / u * 100;
}
function pn(e, t, n, r, a, o) {
  if (pt(e)) {
    const i = n === "horizontal";
    let l = 0;
    e.shiftKey ? l = 100 : a != null ? l = a : l = 10;
    let s = 0;
    switch (e.key) {
      case "ArrowDown":
        s = i ? 0 : l;
        break;
      case "ArrowLeft":
        s = i ? -l : 0;
        break;
      case "ArrowRight":
        s = i ? l : 0;
        break;
      case "ArrowUp":
        s = i ? 0 : -l;
        break;
      case "End":
        s = 100;
        break;
      case "Home":
        s = -100;
        break;
    }
    return s;
  } else
    return r == null ? 0 : gn(e, t, n, r, o);
}
function bn({
  panelDataArray: e
}) {
  const t = Array(e.length), n = e.map((o) => o.constraints);
  let r = 0, a = 100;
  for (let o = 0; o < e.length; o++) {
    const i = n[o];
    S(i, `Panel constraints not found for index ${o}`);
    const {
      defaultSize: l
    } = i;
    l != null && (r++, t[o] = l, a -= l);
  }
  for (let o = 0; o < e.length; o++) {
    const i = n[o];
    S(i, `Panel constraints not found for index ${o}`);
    const {
      defaultSize: l
    } = i;
    if (l != null)
      continue;
    const s = e.length - r, f = a / s;
    r++, t[o] = f, a -= f;
  }
  return t;
}
function de(e, t, n) {
  t.forEach((r, a) => {
    const o = e[a];
    S(o, `Panel data not found for index ${a}`);
    const {
      callbacks: i,
      constraints: l,
      id: s
    } = o, {
      collapsedSize: f = 0,
      collapsible: N
    } = l, g = n[s];
    if (g == null || r !== g) {
      n[s] = r;
      const {
        onCollapse: u,
        onExpand: h,
        onResize: d
      } = i;
      d && d(r, g), N && (u || h) && (h && (g == null || ee(g, f)) && !ee(r, f) && h(), u && (g == null || !ee(g, f)) && ee(r, f) && u());
    }
  });
}
function _e(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] != t[n])
      return !1;
  return !0;
}
function hn({
  defaultSize: e,
  dragState: t,
  layout: n,
  panelData: r,
  panelIndex: a,
  precision: o = 3
}) {
  const i = n[a];
  let l;
  return i == null ? l = e != null ? e.toPrecision(o) : "1" : r.length === 1 ? l = "1" : l = i.toPrecision(o), {
    flexBasis: 0,
    flexGrow: l,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: t !== null ? "none" : void 0
  };
}
function mn(e, t = 10) {
  let n = null;
  return (...a) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...a);
    }, t);
  };
}
function nt(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
function Nt(e) {
  return `react-resizable-panels:${e}`;
}
function Ct(e) {
  return e.map((t) => {
    const {
      constraints: n,
      id: r,
      idIsFromProps: a,
      order: o
    } = t;
    return a ? r : o ? `${o}:${JSON.stringify(n)}` : JSON.stringify(n);
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function Et(e, t) {
  try {
    const n = Nt(e), r = t.getItem(n);
    if (r) {
      const a = JSON.parse(r);
      if (typeof a == "object" && a != null)
        return a;
    }
  } catch {
  }
  return null;
}
function xn(e, t, n) {
  var r, a;
  const o = (r = Et(e, n)) !== null && r !== void 0 ? r : {}, i = Ct(t);
  return (a = o[i]) !== null && a !== void 0 ? a : null;
}
function vn(e, t, n, r, a) {
  var o;
  const i = Nt(e), l = Ct(t), s = (o = Et(e, a)) !== null && o !== void 0 ? o : {};
  s[l] = {
    expandToSizes: Object.fromEntries(n.entries()),
    layout: r
  };
  try {
    a.setItem(i, JSON.stringify(s));
  } catch (f) {
    console.error(f);
  }
}
function rt({
  layout: e,
  panelConstraints: t
}) {
  const n = [...e], r = n.reduce((o, i) => o + i, 0);
  if (n.length !== t.length)
    throw Error(`Invalid ${t.length} panel layout: ${n.map((o) => `${o}%`).join(", ")}`);
  if (!V(r, 100) && n.length > 0)
    for (let o = 0; o < t.length; o++) {
      const i = n[o];
      S(i != null, `No layout data found for index ${o}`);
      const l = 100 / r * i;
      n[o] = l;
    }
  let a = 0;
  for (let o = 0; o < t.length; o++) {
    const i = n[o];
    S(i != null, `No layout data found for index ${o}`);
    const l = fe({
      panelConstraints: t,
      panelIndex: o,
      size: i
    });
    i != l && (a += i - l, n[o] = l);
  }
  if (!V(a, 0))
    for (let o = 0; o < t.length; o++) {
      const i = n[o];
      S(i != null, `No layout data found for index ${o}`);
      const l = i + a, s = fe({
        panelConstraints: t,
        panelIndex: o,
        size: l
      });
      if (i !== s && (a -= s - i, n[o] = s, V(a, 0)))
        break;
    }
  return n;
}
const yn = 100, we = {
  getItem: (e) => (nt(we), we.getItem(e)),
  setItem: (e, t) => {
    nt(we), we.setItem(e, t);
  }
}, ot = {};
function Dt({
  autoSaveId: e = null,
  children: t,
  className: n = "",
  direction: r,
  forwardedRef: a,
  id: o = null,
  onLayout: i = null,
  keyboardResizeBy: l = null,
  storage: s = we,
  style: f,
  tagName: N = "div",
  ...g
}) {
  const u = Ve(o), h = H(null), [d, k] = ie(null), [y, F] = ie([]), E = sn(), R = H({}), A = H(/* @__PURE__ */ new Map()), Y = H(0), P = H({
    autoSaveId: e,
    direction: r,
    dragState: d,
    id: u,
    keyboardResizeBy: l,
    onLayout: i,
    storage: s
  }), C = H({
    layout: y,
    panelDataArray: [],
    panelDataArrayChanged: !1
  });
  H({
    didLogIdAndOrderWarning: !1,
    didLogPanelConstraintsWarning: !1,
    prevPanelIds: []
  }), st(a, () => ({
    getId: () => P.current.id,
    getLayout: () => {
      const {
        layout: p
      } = C.current;
      return p;
    },
    setLayout: (p) => {
      const {
        onLayout: v
      } = P.current, {
        layout: _,
        panelDataArray: x
      } = C.current, b = rt({
        layout: p,
        panelConstraints: x.map((w) => w.constraints)
      });
      tt(_, b) || (F(b), C.current.layout = b, v && v(b), de(x, b, R.current));
    }
  }), []), le(() => {
    P.current.autoSaveId = e, P.current.direction = r, P.current.dragState = d, P.current.id = u, P.current.onLayout = i, P.current.storage = s;
  }), fn({
    committedValuesRef: P,
    eagerValuesRef: C,
    groupId: u,
    layout: y,
    panelDataArray: C.current.panelDataArray,
    setLayout: F,
    panelGroupElement: h.current
  }), te(() => {
    const {
      panelDataArray: p
    } = C.current;
    if (e) {
      if (y.length === 0 || y.length !== p.length)
        return;
      let v = ot[e];
      v == null && (v = mn(vn, yn), ot[e] = v);
      const _ = [...p], x = new Map(A.current);
      v(e, _, x, y, s);
    }
  }, [e, y, s]), te(() => {
  });
  const K = j((p) => {
    const {
      onLayout: v
    } = P.current, {
      layout: _,
      panelDataArray: x
    } = C.current;
    if (p.constraints.collapsible) {
      const b = x.map((Z) => Z.constraints), {
        collapsedSize: w = 0,
        panelSize: D,
        pivotIndices: M
      } = oe(x, p, _);
      if (S(D != null, `Panel size not found for panel "${p.id}"`), !ee(D, w)) {
        A.current.set(p.id, D);
        const J = ue(x, p) === x.length - 1 ? D - w : w - D, B = Fe({
          delta: J,
          initialLayout: _,
          panelConstraints: b,
          pivotIndices: M,
          prevLayout: _,
          trigger: "imperative-api"
        });
        _e(_, B) || (F(B), C.current.layout = B, v && v(B), de(x, B, R.current));
      }
    }
  }, []), Q = j((p, v) => {
    const {
      onLayout: _
    } = P.current, {
      layout: x,
      panelDataArray: b
    } = C.current;
    if (p.constraints.collapsible) {
      const w = b.map((q) => q.constraints), {
        collapsedSize: D = 0,
        panelSize: M = 0,
        minSize: Z = 0,
        pivotIndices: J
      } = oe(b, p, x), B = v ?? Z;
      if (ee(M, D)) {
        const q = A.current.get(p.id), ve = q != null && q >= B ? q : B, Ae = ue(b, p) === b.length - 1 ? M - ve : ve - M, O = Fe({
          delta: Ae,
          initialLayout: x,
          panelConstraints: w,
          pivotIndices: J,
          prevLayout: x,
          trigger: "imperative-api"
        });
        _e(x, O) || (F(O), C.current.layout = O, _ && _(O), de(b, O, R.current));
      }
    }
  }, []), U = j((p) => {
    const {
      layout: v,
      panelDataArray: _
    } = C.current, {
      panelSize: x
    } = oe(_, p, v);
    return S(x != null, `Panel size not found for panel "${p.id}"`), x;
  }, []), T = j((p, v) => {
    const {
      panelDataArray: _
    } = C.current, x = ue(_, p);
    return hn({
      defaultSize: v,
      dragState: d,
      layout: y,
      panelData: _,
      panelIndex: x
    });
  }, [d, y]), I = j((p) => {
    const {
      layout: v,
      panelDataArray: _
    } = C.current, {
      collapsedSize: x = 0,
      collapsible: b,
      panelSize: w
    } = oe(_, p, v);
    return S(w != null, `Panel size not found for panel "${p.id}"`), b === !0 && ee(w, x);
  }, []), re = j((p) => {
    const {
      layout: v,
      panelDataArray: _
    } = C.current, {
      collapsedSize: x = 0,
      collapsible: b,
      panelSize: w
    } = oe(_, p, v);
    return S(w != null, `Panel size not found for panel "${p.id}"`), !b || se(w, x) > 0;
  }, []), G = j((p) => {
    const {
      panelDataArray: v
    } = C.current;
    v.push(p), v.sort((_, x) => {
      const b = _.order, w = x.order;
      return b == null && w == null ? 0 : b == null ? -1 : w == null ? 1 : b - w;
    }), C.current.panelDataArrayChanged = !0, E();
  }, [E]);
  le(() => {
    if (C.current.panelDataArrayChanged) {
      C.current.panelDataArrayChanged = !1;
      const {
        autoSaveId: p,
        onLayout: v,
        storage: _
      } = P.current, {
        layout: x,
        panelDataArray: b
      } = C.current;
      let w = null;
      if (p) {
        const M = xn(p, b, _);
        M && (A.current = new Map(Object.entries(M.expandToSizes)), w = M.layout);
      }
      w == null && (w = bn({
        panelDataArray: b
      }));
      const D = rt({
        layout: w,
        panelConstraints: b.map((M) => M.constraints)
      });
      tt(x, D) || (F(D), C.current.layout = D, v && v(D), de(b, D, R.current));
    }
  }), le(() => {
    const p = C.current;
    return () => {
      p.layout = [];
    };
  }, []);
  const $ = j((p) => {
    let v = !1;
    const _ = h.current;
    return _ && window.getComputedStyle(_, null).getPropertyValue("direction") === "rtl" && (v = !0), function(b) {
      b.preventDefault();
      const w = h.current;
      if (!w)
        return () => null;
      const {
        direction: D,
        dragState: M,
        id: Z,
        keyboardResizeBy: J,
        onLayout: B
      } = P.current, {
        layout: q,
        panelDataArray: ve
      } = C.current, {
        initialLayout: ke
      } = M ?? {}, Ae = zt(Z, p, w);
      let O = pn(b, p, D, M, J, w);
      const Xe = D === "horizontal";
      Xe && v && (O = -O);
      const Lt = ve.map((It) => It.constraints), ye = Fe({
        delta: O,
        initialLayout: ke ?? q,
        panelConstraints: Lt,
        pivotIndices: Ae,
        prevLayout: q,
        trigger: pt(b) ? "keyboard" : "mouse-or-touch"
      }), Ye = !_e(q, ye);
      (bt(b) || ht(b)) && Y.current != O && (Y.current = O, !Ye && O !== 0 ? Xe ? We(p, O < 0 ? xt : vt) : We(p, O < 0 ? yt : Ft) : We(p, 0)), Ye && (F(ye), C.current.layout = ye, B && B(ye), de(ve, ye, R.current));
    };
  }, []), W = j((p, v) => {
    const {
      onLayout: _
    } = P.current, {
      layout: x,
      panelDataArray: b
    } = C.current, w = b.map((q) => q.constraints), {
      panelSize: D,
      pivotIndices: M
    } = oe(b, p, x);
    S(D != null, `Panel size not found for panel "${p.id}"`);
    const J = ue(b, p) === b.length - 1 ? D - v : v - D, B = Fe({
      delta: J,
      initialLayout: x,
      panelConstraints: w,
      pivotIndices: M,
      prevLayout: x,
      trigger: "imperative-api"
    });
    _e(x, B) || (F(B), C.current.layout = B, _ && _(B), de(b, B, R.current));
  }, []), be = j((p, v) => {
    const {
      layout: _,
      panelDataArray: x
    } = C.current, {
      collapsedSize: b = 0,
      collapsible: w
    } = v, {
      collapsedSize: D = 0,
      collapsible: M,
      maxSize: Z = 100,
      minSize: J = 0
    } = p.constraints, {
      panelSize: B
    } = oe(x, p, _);
    B != null && (w && M && ee(B, b) ? ee(b, D) || W(p, D) : B < J ? W(p, J) : B > Z && W(p, Z));
  }, [W]), he = j((p, v) => {
    const {
      direction: _
    } = P.current, {
      layout: x
    } = C.current;
    if (!h.current)
      return;
    const b = Re(p, h.current);
    S(b, `Drag handle element not found for id "${p}"`);
    const w = _t(_, v);
    k({
      dragHandleId: p,
      dragHandleRect: b.getBoundingClientRect(),
      initialCursorPosition: w,
      initialLayout: x
    });
  }, []), me = j(() => {
    k(null);
  }, []), Me = j((p) => {
    const {
      panelDataArray: v
    } = C.current, _ = ue(v, p);
    _ >= 0 && (v.splice(_, 1), delete R.current[p.id], C.current.panelDataArrayChanged = !0, E());
  }, [E]), ce = $t(() => ({
    collapsePanel: K,
    direction: r,
    dragState: d,
    expandPanel: Q,
    getPanelSize: U,
    getPanelStyle: T,
    groupId: u,
    isPanelCollapsed: I,
    isPanelExpanded: re,
    reevaluatePanelConstraints: be,
    registerPanel: G,
    registerResizeHandle: $,
    resizePanel: W,
    startDragging: he,
    stopDragging: me,
    unregisterPanel: Me,
    panelGroupElement: h.current
  }), [K, d, r, Q, U, T, u, I, re, be, G, $, W, he, me, Me]), xe = {
    display: "flex",
    flexDirection: r === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return pe(Be.Provider, {
    value: ce
  }, pe(N, {
    ...g,
    children: t,
    className: n,
    id: o,
    ref: h,
    style: {
      ...xe,
      ...f
    },
    // CSS selectors
    [L.group]: "",
    [L.groupDirection]: r,
    [L.groupId]: u
  }));
}
const Pt = it((e, t) => pe(Dt, {
  ...e,
  forwardedRef: t
}));
Dt.displayName = "PanelGroup";
Pt.displayName = "forwardRef(PanelGroup)";
function ue(e, t) {
  return e.findIndex((n) => n === t || n.id === t.id);
}
function oe(e, t, n) {
  const r = ue(e, t), o = r === e.length - 1 ? [r - 1, r] : [r, r + 1], i = n[r];
  return {
    ...t.constraints,
    panelSize: i,
    pivotIndices: o
  };
}
function Fn({
  disabled: e,
  handleId: t,
  resizeHandler: n,
  panelGroupElement: r
}) {
  te(() => {
    if (e || n == null || r == null)
      return;
    const a = Re(t, r);
    if (a == null)
      return;
    const o = (i) => {
      if (!i.defaultPrevented)
        switch (i.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            i.preventDefault(), n(i);
            break;
          }
          case "F6": {
            i.preventDefault();
            const l = a.getAttribute(L.groupId);
            S(l, `No group element found for id "${l}"`);
            const s = ze(l, r), f = St(l, t, r);
            S(f !== null, `No resize element found for id "${t}"`);
            const N = i.shiftKey ? f > 0 ? f - 1 : s.length - 1 : f + 1 < s.length ? f + 1 : 0;
            s[N].focus();
            break;
          }
        }
    };
    return a.addEventListener("keydown", o), () => {
      a.removeEventListener("keydown", o);
    };
  }, [r, e, t, n]);
}
function Bt({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  hitAreaMargins: r,
  id: a,
  onBlur: o,
  onClick: i,
  onDragging: l,
  onFocus: s,
  onPointerDown: f,
  onPointerUp: N,
  style: g = {},
  tabIndex: u = 0,
  tagName: h = "div",
  ...d
}) {
  var k, y;
  const F = H(null), E = H({
    onClick: i,
    onDragging: l,
    onPointerDown: f,
    onPointerUp: N
  });
  te(() => {
    E.current.onClick = i, E.current.onDragging = l, E.current.onPointerDown = f, E.current.onPointerUp = N;
  });
  const R = lt(Be);
  if (R === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    direction: A,
    groupId: Y,
    registerResizeHandle: P,
    startDragging: C,
    stopDragging: K,
    panelGroupElement: Q
  } = R, U = Ve(a), [T, I] = ie("inactive"), [re, G] = ie(!1), [$, W] = ie(null), be = H({
    state: T
  });
  le(() => {
    be.current.state = T;
  }), te(() => {
    if (n)
      W(null);
    else {
      const ce = P(U);
      W(() => ce);
    }
  }, [n, U, P]);
  const he = (k = r == null ? void 0 : r.coarse) !== null && k !== void 0 ? k : 15, me = (y = r == null ? void 0 : r.fine) !== null && y !== void 0 ? y : 5;
  return te(() => {
    if (n || $ == null)
      return;
    const ce = F.current;
    S(ce, "Element ref not attached");
    let xe = !1;
    return an(U, ce, A, {
      coarse: he,
      fine: me
    }, (v, _, x) => {
      if (!_) {
        I("inactive");
        return;
      }
      switch (v) {
        case "down": {
          I("drag"), xe = !1, S(x, 'Expected event to be defined for "down" action'), C(U, x);
          const {
            onDragging: b,
            onPointerDown: w
          } = E.current;
          b == null || b(!0), w == null || w();
          break;
        }
        case "move": {
          const {
            state: b
          } = be.current;
          xe = !0, b !== "drag" && I("hover"), S(x, 'Expected event to be defined for "move" action'), $(x);
          break;
        }
        case "up": {
          I("hover"), K();
          const {
            onClick: b,
            onDragging: w,
            onPointerUp: D
          } = E.current;
          w == null || w(!1), D == null || D(), xe || b == null || b();
          break;
        }
      }
    });
  }, [he, A, n, me, P, U, $, C, K]), Fn({
    disabled: n,
    handleId: U,
    resizeHandler: $,
    panelGroupElement: Q
  }), pe(h, {
    ...d,
    children: e,
    className: t,
    id: a,
    onBlur: () => {
      G(!1), o == null || o();
    },
    onFocus: () => {
      G(!0), s == null || s();
    },
    ref: F,
    role: "separator",
    style: {
      ...{
        touchAction: "none",
        userSelect: "none"
      },
      ...g
    },
    tabIndex: u,
    // CSS selectors
    [L.groupDirection]: A,
    [L.groupId]: Y,
    [L.resizeHandle]: "",
    [L.resizeHandleActive]: T === "drag" ? "pointer" : re ? "keyboard" : void 0,
    [L.resizeHandleEnabled]: !n,
    [L.resizeHandleId]: U,
    [L.resizeHandleState]: T
  });
}
Bt.displayName = "PanelResizeHandle";
const wn = ({
  direction: e = "horizontal",
  children: t,
  className: n
}) => /* @__PURE__ */ c(
  Pt,
  {
    direction: e,
    className: m("holo-split-pane", n),
    children: t
  }
);
wn.displayName = "SplitPane";
const Sn = ({
  defaultSize: e,
  minSize: t = 10,
  maxSize: n,
  collapsible: r = !1,
  children: a,
  className: o,
  order: i
}) => /* @__PURE__ */ c(
  gt,
  {
    defaultSize: e,
    minSize: t,
    maxSize: n,
    collapsible: r,
    order: i,
    className: m(
      "holo-pane",
      "overflow-hidden",
      o
    ),
    children: a
  }
);
Sn.displayName = "Pane";
const zn = ({
  direction: e = "horizontal",
  className: t
}) => /* @__PURE__ */ c(
  Bt,
  {
    className: m(
      "holo-resize-handle",
      "relative group",
      "transition-colors duration-150",
      // Direction-specific styles
      e === "horizontal" ? [
        "w-1 cursor-col-resize",
        "hover:bg-[var(--holo-accent-cyan)]"
      ] : [
        "h-1 cursor-row-resize",
        "hover:bg-[var(--holo-accent-cyan)]"
      ],
      // Base background
      "bg-[var(--holo-border)]",
      t
    ),
    children: /* @__PURE__ */ c(
      "div",
      {
        className: m(
          "absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity",
          "shadow-[0_0_8px_var(--holo-accent-cyan)]"
        )
      }
    )
  }
);
zn.displayName = "ResizeHandle";
function kn({
  density: e = 5,
  showNebula: t = !0,
  showVignette: n = !0,
  className: r
}) {
  const a = H(null), o = H([]), i = H();
  return te(() => {
    const l = a.current;
    if (!l) return;
    const s = l.getContext("2d");
    if (!s) return;
    const f = () => {
      l.width = window.innerWidth, l.height = window.innerHeight, N();
    }, N = () => {
      const h = Math.floor(l.width * l.height / (16e3 / e));
      o.current = [];
      for (let d = 0; d < h; d++)
        o.current.push({
          x: Math.random() * l.width,
          y: Math.random() * l.height,
          size: Math.random() * 1.5 + 0.5,
          opacity: Math.random() * 0.8 + 0.2,
          speed: Math.random() * 0.3 + 0.1
        });
    }, g = () => {
      if (!s || !l) return;
      const h = s.createLinearGradient(0, 0, 0, l.height);
      h.addColorStop(0, "#050508"), h.addColorStop(0.5, "#0a0e1a"), h.addColorStop(1, "#0d1526"), s.fillStyle = h, s.fillRect(0, 0, l.width, l.height), t && u(s, l.width, l.height), o.current.forEach((d) => {
        const k = Math.sin(Date.now() * 2e-3 * d.speed + d.x) * 0.3 + 0.7;
        if (s.beginPath(), s.arc(d.x, d.y, d.size, 0, Math.PI * 2), s.fillStyle = `rgba(200, 220, 255, ${d.opacity * k})`, s.fill(), d.size > 1) {
          s.beginPath(), s.arc(d.x, d.y, d.size * 2, 0, Math.PI * 2);
          const y = s.createRadialGradient(
            d.x,
            d.y,
            0,
            d.x,
            d.y,
            d.size * 2
          );
          y.addColorStop(0, `rgba(0, 212, 255, ${0.3 * k})`), y.addColorStop(1, "transparent"), s.fillStyle = y, s.fill();
        }
        d.y += d.speed * 0.5, d.y > l.height && (d.y = 0, d.x = Math.random() * l.width);
      }), i.current = requestAnimationFrame(g);
    }, u = (h, d, k) => {
      const y = Date.now() * 1e-4, F = h.createRadialGradient(
        d * 0.3 + Math.sin(y) * 50,
        k * 0.4 + Math.cos(y) * 30,
        0,
        d * 0.3,
        k * 0.4,
        d * 0.4
      );
      F.addColorStop(0, "rgba(123, 104, 238, 0.08)"), F.addColorStop(0.5, "rgba(123, 104, 238, 0.03)"), F.addColorStop(1, "transparent"), h.fillStyle = F, h.fillRect(0, 0, d, k);
      const E = h.createRadialGradient(
        d * 0.7 + Math.cos(y * 0.8) * 40,
        k * 0.6 + Math.sin(y * 0.8) * 40,
        0,
        d * 0.7,
        k * 0.6,
        d * 0.35
      );
      E.addColorStop(0, "rgba(0, 212, 255, 0.06)"), E.addColorStop(0.5, "rgba(0, 212, 255, 0.02)"), E.addColorStop(1, "transparent"), h.fillStyle = E, h.fillRect(0, 0, d, k);
    };
    return f(), g(), window.addEventListener("resize", f), () => {
      window.removeEventListener("resize", f), i.current && cancelAnimationFrame(i.current);
    };
  }, [e, t]), /* @__PURE__ */ z(Pe, { children: [
    /* @__PURE__ */ c(
      "canvas",
      {
        ref: a,
        className: m(
          "holo-starfield",
          "fixed inset-0 w-full h-full",
          "z-0",
          r
        )
      }
    ),
    n && /* @__PURE__ */ c(
      "div",
      {
        className: "fixed inset-0 w-full h-full pointer-events-none z-[1]",
        style: {
          background: "radial-gradient(ellipse at center, transparent 0%, rgba(0, 0, 0, 0.4) 100%)"
        }
      }
    )
  ] });
}
kn.displayName = "StarfieldBackground";
const _n = ({
  direction: e = "horizontal",
  duration: t = 4,
  opacity: n = 0.1,
  className: r
}) => /* @__PURE__ */ c(
  "div",
  {
    className: m(
      "holo-scanline",
      "absolute inset-0 pointer-events-none overflow-hidden",
      r
    ),
    children: /* @__PURE__ */ c(
      "div",
      {
        className: m(
          "absolute",
          e === "horizontal" ? "left-0 right-0 h-px" : "top-0 bottom-0 w-px"
        ),
        style: {
          background: e === "horizontal" ? "linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.5), transparent)" : "linear-gradient(180deg, transparent, rgba(0, 212, 255, 0.5), transparent)",
          opacity: n,
          animation: e === "horizontal" ? `holo-scanline ${t}s linear infinite` : `holo-scanline-h ${t}s linear infinite`
        }
      }
    )
  }
);
_n.displayName = "ScanLine";
const Nn = ({
  cellSize: e = 50,
  opacity: t = 0.03,
  className: n
}) => /* @__PURE__ */ c(
  "div",
  {
    className: m(
      "holo-grid-overlay",
      "absolute inset-0 pointer-events-none",
      n
    ),
    style: {
      backgroundImage: `
          linear-gradient(to right, rgba(0, 212, 255, ${t}) 1px, transparent 1px),
          linear-gradient(to bottom, rgba(0, 212, 255, ${t}) 1px, transparent 1px)
        `,
      backgroundSize: `${e}px ${e}px`
    }
  }
);
Nn.displayName = "GridOverlay";
const Cn = ({
  duration: e = 2,
  className: t
}) => /* @__PURE__ */ c(
  "div",
  {
    className: m(
      "holo-shimmer",
      "absolute inset-0 pointer-events-none overflow-hidden",
      t
    ),
    children: /* @__PURE__ */ c(
      "div",
      {
        className: "absolute inset-0",
        style: {
          background: "linear-gradient(90deg, transparent 0%, rgba(0, 212, 255, 0.1) 50%, transparent 100%)",
          backgroundSize: "200% 100%",
          animation: `holo-shimmer ${e}s ease-in-out infinite`
        }
      }
    )
  }
);
Cn.displayName = "Shimmer";
const En = {
  cyan: { bg: "bg-[#00D4FF]", glow: "shadow-[0_0_15px_rgba(0,212,255,0.6)]" },
  amber: { bg: "bg-[#FFB347]", glow: "shadow-[0_0_15px_rgba(255,179,71,0.6)]" },
  purple: { bg: "bg-[#9D8CFF]", glow: "shadow-[0_0_15px_rgba(157,140,255,0.6)]" },
  green: { bg: "bg-[#00FF88]", glow: "shadow-[0_0_15px_rgba(0,255,136,0.6)]" },
  red: { bg: "bg-[#FF6B6B]", glow: "shadow-[0_0_15px_rgba(255,107,107,0.6)]" },
  blue: { bg: "bg-[#6B9FFF]", glow: "shadow-[0_0_15px_rgba(107,159,255,0.6)]" }
}, Dn = {
  horizontal: {
    sm: "h-2 min-w-8",
    md: "h-4 min-w-12",
    lg: "h-6 min-w-16"
  },
  vertical: {
    sm: "w-2 min-h-8",
    md: "w-4 min-h-12",
    lg: "w-6 min-h-16"
  }
}, qn = ({
  color: e = "cyan",
  direction: t = "horizontal",
  size: n = "md",
  animated: r = !1,
  className: a,
  label: o
}) => {
  const { bg: i, glow: l } = En[e], s = Dn[t][n];
  return /* @__PURE__ */ c(
    "div",
    {
      className: m(
        "relative flex items-center justify-center",
        i,
        s,
        t === "horizontal" ? "rounded-l-full rounded-r-[4px]" : "rounded-t-full rounded-b-[4px]",
        r && l,
        r && "animate-pulse",
        a
      ),
      children: o && /* @__PURE__ */ c("span", { className: m(
        "text-[10px] font-bold tracking-wider text-black uppercase",
        t === "vertical" && "writing-mode-vertical"
      ), children: o })
    }
  );
}, Pn = {
  cyan: {
    bg: "bg-[#00D4FF]",
    border: "border-[rgba(0,212,255,0.3)]",
    text: "text-[#00D4FF]"
  },
  amber: {
    bg: "bg-[#FFB347]",
    border: "border-[rgba(255,179,71,0.3)]",
    text: "text-[#FFB347]"
  },
  purple: {
    bg: "bg-[#9D8CFF]",
    border: "border-[rgba(157,140,255,0.3)]",
    text: "text-[#9D8CFF]"
  },
  green: {
    bg: "bg-[#00FF88]",
    border: "border-[rgba(0,255,136,0.3)]",
    text: "text-[#00FF88]"
  },
  red: {
    bg: "bg-[#FF6B6B]",
    border: "border-[rgba(255,107,107,0.3)]",
    text: "text-[#FF6B6B]"
  },
  blue: {
    bg: "bg-[#6B9FFF]",
    border: "border-[rgba(107,159,255,0.3)]",
    text: "text-[#6B9FFF]"
  }
}, Xn = ({
  title: e,
  color: t = "cyan",
  headerPosition: n = "top",
  children: r,
  className: a,
  active: o = !1
}) => {
  const { bg: i, border: l } = Pn[t];
  return n === "left" ? /* @__PURE__ */ z("div", { className: m("flex", a), children: [
    /* @__PURE__ */ z("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ c("div", { className: m(
        "w-6 rounded-tl-[20px] rounded-bl-[4px] flex-1 min-h-[60px]",
        i,
        o && "shadow-[0_0_20px_rgba(0,212,255,0.5)]"
      ) }),
      e && /* @__PURE__ */ c("div", { className: m(
        "w-6 py-2 flex items-center justify-center",
        i
      ), children: /* @__PURE__ */ c(
        "span",
        {
          className: "text-[10px] font-bold tracking-wider text-black uppercase",
          style: { writingMode: "vertical-rl", transform: "rotate(180deg)" },
          children: e
        }
      ) }),
      /* @__PURE__ */ c("div", { className: m("w-6 h-4 rounded-bl-[20px]", i) })
    ] }),
    /* @__PURE__ */ c("div", { className: m(
      "flex-1 border-t border-b border-r rounded-tr-lg rounded-br-lg",
      l,
      "bg-[rgba(5,5,15,0.8)]"
    ), children: r })
  ] }) : /* @__PURE__ */ z("div", { className: m("flex flex-col overflow-hidden", a), children: [
    /* @__PURE__ */ z("div", { className: "flex items-stretch flex-shrink-0", children: [
      /* @__PURE__ */ c("div", { className: m(
        "h-8 rounded-tl-[20px] flex-shrink-0",
        i,
        o && "shadow-[0_0_20px_rgba(0,212,255,0.5)]"
      ), style: { width: "60px" } }),
      e && /* @__PURE__ */ c("div", { className: m(
        "h-8 px-4 flex items-center",
        i
      ), children: /* @__PURE__ */ c("span", { className: "text-[11px] font-bold tracking-[2px] text-black uppercase", children: e }) }),
      /* @__PURE__ */ c("div", { className: m("h-8 flex-1 rounded-tr-[4px]", i) })
    ] }),
    /* @__PURE__ */ c("div", { className: m(
      "flex-1 min-h-0 overflow-hidden border-l border-b border-r rounded-bl-lg rounded-br-lg",
      l,
      "bg-[rgba(5,5,15,0.8)]"
    ), children: r })
  ] });
}, Bn = {
  cyan: {
    bg: "bg-[#00D4FF]",
    bgHover: "hover:bg-[#33DDFF]",
    bgActive: "bg-[#00A8CC]",
    glow: "shadow-[0_0_20px_rgba(0,212,255,0.6)]"
  },
  amber: {
    bg: "bg-[#FFB347]",
    bgHover: "hover:bg-[#FFC266]",
    bgActive: "bg-[#E69A30]",
    glow: "shadow-[0_0_20px_rgba(255,179,71,0.6)]"
  },
  purple: {
    bg: "bg-[#9D8CFF]",
    bgHover: "hover:bg-[#B3A6FF]",
    bgActive: "bg-[#8677E6]",
    glow: "shadow-[0_0_20px_rgba(157,140,255,0.6)]"
  },
  green: {
    bg: "bg-[#00FF88]",
    bgHover: "hover:bg-[#33FF9F]",
    bgActive: "bg-[#00CC6D]",
    glow: "shadow-[0_0_20px_rgba(0,255,136,0.6)]"
  },
  red: {
    bg: "bg-[#FF6B6B]",
    bgHover: "hover:bg-[#FF8585]",
    bgActive: "bg-[#E65555]",
    glow: "shadow-[0_0_20px_rgba(255,107,107,0.6)]"
  },
  blue: {
    bg: "bg-[#6B9FFF]",
    bgHover: "hover:bg-[#85B0FF]",
    bgActive: "bg-[#5588E6]",
    glow: "shadow-[0_0_20px_rgba(107,159,255,0.6)]"
  }
}, Ln = {
  sm: "h-7 px-3 text-[10px]",
  md: "h-9 px-4 text-[11px]",
  lg: "h-11 px-6 text-[12px]"
}, In = {
  pill: "rounded-full",
  rounded: "rounded-lg",
  square: "rounded-[4px]"
}, Yn = ({
  children: e,
  color: t = "cyan",
  size: n = "md",
  active: r = !1,
  disabled: a = !1,
  onClick: o,
  className: i,
  shape: l = "pill"
}) => {
  const { bg: s, bgHover: f, bgActive: N, glow: g } = Bn[t];
  return /* @__PURE__ */ c(
    "button",
    {
      onClick: o,
      disabled: a,
      className: m(
        "font-bold tracking-[1px] uppercase transition-all duration-200",
        "text-black flex items-center justify-center gap-2",
        Ln[n],
        In[l],
        r ? N : s,
        !a && f,
        r && g,
        a && "opacity-50 cursor-not-allowed",
        !a && "cursor-pointer active:scale-95",
        i
      ),
      children: e
    }
  );
}, Rn = {
  active: "bg-[#00D4FF] shadow-[0_0_8px_rgba(0,212,255,0.8)]",
  idle: "bg-[rgba(232,244,248,0.3)]",
  warning: "bg-[#FFB347] shadow-[0_0_8px_rgba(255,179,71,0.8)]",
  error: "bg-[#FF6B6B] shadow-[0_0_8px_rgba(255,107,107,0.8)]",
  success: "bg-[#00FF88] shadow-[0_0_8px_rgba(0,255,136,0.8)]"
}, Mn = {
  cyan: "bg-[#00D4FF]",
  amber: "bg-[#FFB347]",
  purple: "bg-[#9D8CFF]",
  green: "bg-[#00FF88]",
  red: "bg-[#FF6B6B]",
  blue: "bg-[#6B9FFF]"
}, Zn = ({
  children: e,
  status: t = "idle",
  icon: n,
  selected: r = !1,
  onClick: a,
  color: o = "cyan",
  className: i
}) => /* @__PURE__ */ z(
  "button",
  {
    onClick: a,
    className: m(
      "w-full flex items-center gap-3 px-3 py-2 transition-all duration-200",
      "text-left group",
      r ? "bg-[rgba(0,212,255,0.15)]" : "hover:bg-[rgba(0,212,255,0.08)]",
      i
    ),
    children: [
      /* @__PURE__ */ c("div", { className: m(
        "w-1 h-6 rounded-full transition-all duration-200",
        r ? Mn[o] : "bg-[rgba(232,244,248,0.1)]",
        r && "shadow-[0_0_8px_rgba(0,212,255,0.5)]"
      ) }),
      /* @__PURE__ */ c("div", { className: m(
        "w-2 h-2 rounded-full flex-shrink-0",
        Rn[t]
      ) }),
      n && /* @__PURE__ */ c("div", { className: m(
        "w-4 h-4 flex-shrink-0",
        r ? "text-[#00D4FF]" : "text-[rgba(232,244,248,0.5)]"
      ), children: n }),
      /* @__PURE__ */ c("span", { className: m(
        "flex-1 text-[12px] font-medium truncate transition-colors",
        r ? "text-[#00D4FF]" : "text-[rgba(232,244,248,0.7)] group-hover:text-[rgba(232,244,248,0.9)]"
      ), children: e })
    ]
  }
), Jn = ({
  children: e,
  className: t,
  title: n
}) => /* @__PURE__ */ z("div", { className: m("flex flex-col", t), children: [
  n && /* @__PURE__ */ c("div", { className: "px-3 py-2 border-b border-[rgba(0,212,255,0.2)]", children: /* @__PURE__ */ c("span", { className: "text-[10px] font-bold tracking-[2px] uppercase text-[rgba(232,244,248,0.5)]", children: n }) }),
  /* @__PURE__ */ c("div", { className: "flex flex-col", children: e })
] }), An = {
  cyan: {
    bg: "bg-[rgba(0,212,255,0.15)]",
    bgActive: "bg-[rgba(0,212,255,0.3)]",
    border: "border-[#00D4FF]",
    glow: "shadow-[0_0_20px_rgba(0,212,255,0.4),inset_0_0_20px_rgba(0,212,255,0.1)]",
    text: "text-[#00D4FF]"
  },
  amber: {
    bg: "bg-[rgba(255,179,71,0.15)]",
    bgActive: "bg-[rgba(255,179,71,0.3)]",
    border: "border-[#FFB347]",
    glow: "shadow-[0_0_20px_rgba(255,179,71,0.4),inset_0_0_20px_rgba(255,179,71,0.1)]",
    text: "text-[#FFB347]"
  },
  purple: {
    bg: "bg-[rgba(157,140,255,0.15)]",
    bgActive: "bg-[rgba(157,140,255,0.3)]",
    border: "border-[#9D8CFF]",
    glow: "shadow-[0_0_20px_rgba(157,140,255,0.4),inset_0_0_20px_rgba(157,140,255,0.1)]",
    text: "text-[#9D8CFF]"
  },
  green: {
    bg: "bg-[rgba(0,255,136,0.15)]",
    bgActive: "bg-[rgba(0,255,136,0.3)]",
    border: "border-[#00FF88]",
    glow: "shadow-[0_0_20px_rgba(0,255,136,0.4),inset_0_0_20px_rgba(0,255,136,0.1)]",
    text: "text-[#00FF88]"
  },
  red: {
    bg: "bg-[rgba(255,107,107,0.15)]",
    bgActive: "bg-[rgba(255,107,107,0.3)]",
    border: "border-[#FF6B6B]",
    glow: "shadow-[0_0_20px_rgba(255,107,107,0.4),inset_0_0_20px_rgba(255,107,107,0.1)]",
    text: "text-[#FF6B6B]"
  },
  blue: {
    bg: "bg-[rgba(107,159,255,0.15)]",
    bgActive: "bg-[rgba(107,159,255,0.3)]",
    border: "border-[#6B9FFF]",
    glow: "shadow-[0_0_20px_rgba(107,159,255,0.4),inset_0_0_20px_rgba(107,159,255,0.1)]",
    text: "text-[#6B9FFF]"
  }
}, $n = {
  online: "bg-[#00FF88] shadow-[0_0_6px_rgba(0,255,136,0.8)]",
  offline: "bg-[rgba(232,244,248,0.3)]",
  warning: "bg-[#FFB347] shadow-[0_0_6px_rgba(255,179,71,0.8)]"
}, Qn = ({
  name: e,
  color: t = "cyan",
  active: n = !1,
  status: r = "online",
  onClick: a,
  className: o,
  icon: i
}) => {
  const { bg: l, bgActive: s, border: f, glow: N, text: g } = An[t];
  return /* @__PURE__ */ z(
    "button",
    {
      onClick: a,
      className: m(
        "relative w-full px-3 py-3 transition-all duration-300",
        "border-l-4 rounded-r-lg",
        "flex items-center gap-3",
        "group cursor-pointer",
        n ? s : l,
        n ? f : "border-transparent",
        n && N,
        "hover:border-opacity-50",
        !n && `hover:${s}`,
        o
      ),
      children: [
        /* @__PURE__ */ c("div", { className: m(
          "w-2 h-2 rounded-full flex-shrink-0",
          $n[r]
        ) }),
        i && /* @__PURE__ */ c("div", { className: m(
          "w-5 h-5 flex-shrink-0 transition-colors",
          n ? g : "text-[rgba(232,244,248,0.5)] group-hover:text-[rgba(232,244,248,0.8)]"
        ), children: i }),
        /* @__PURE__ */ c("span", { className: m(
          "text-[11px] font-bold tracking-[1px] uppercase transition-colors",
          n ? g : "text-[rgba(232,244,248,0.6)] group-hover:text-[rgba(232,244,248,0.9)]"
        ), children: e }),
        n && /* @__PURE__ */ c("div", { className: m(
          "absolute right-0 top-1/2 -translate-y-1/2 w-0 h-0",
          "border-t-[8px] border-t-transparent",
          "border-b-[8px] border-b-transparent",
          "border-r-[8px]",
          t === "cyan" && "border-r-[#00D4FF]",
          t === "amber" && "border-r-[#FFB347]",
          t === "purple" && "border-r-[#9D8CFF]",
          t === "green" && "border-r-[#00FF88]",
          t === "red" && "border-r-[#FF6B6B]",
          t === "blue" && "border-r-[#6B9FFF]"
        ) })
      ]
    }
  );
}, at = {
  online: {
    color: "#00FF88",
    glow: "rgba(0, 255, 136, 0.6)",
    label: "Online"
  },
  offline: {
    color: "rgba(232, 244, 248, 0.3)",
    glow: "transparent",
    label: "Offline"
  },
  busy: {
    color: "#FF6B6B",
    glow: "rgba(255, 107, 107, 0.6)",
    label: "Busy"
  },
  away: {
    color: "#FFB347",
    glow: "rgba(255, 179, 71, 0.6)",
    label: "Away"
  }
}, Hn = {
  sm: { badge: 24, inner: 8, border: 2 },
  md: { badge: 32, inner: 12, border: 2 },
  lg: { badge: 40, inner: 16, border: 3 }
}, er = ({
  status: e = "online",
  size: t = "md",
  animated: n = !0,
  className: r,
  onClick: a
}) => {
  const { color: o, glow: i } = at[e], { badge: l, inner: s, border: f } = Hn[t];
  return /* @__PURE__ */ z(
    "button",
    {
      onClick: a,
      className: m(
        "relative flex items-center justify-center transition-all duration-300",
        a && "cursor-pointer hover:scale-110",
        !a && "cursor-default",
        r
      ),
      style: {
        width: l,
        height: l
      },
      "aria-label": `Status: ${at[e].label}`,
      children: [
        n && e !== "offline" && /* @__PURE__ */ c(
          "div",
          {
            className: "absolute inset-0 rounded-full animate-ping",
            style: {
              background: i,
              opacity: 0.3,
              animationDuration: "2s"
            }
          }
        ),
        /* @__PURE__ */ z(
          "svg",
          {
            viewBox: "0 0 24 24",
            width: l,
            height: l,
            className: "relative z-10",
            children: [
              /* @__PURE__ */ c(
                "path",
                {
                  d: "M12 2 L22 20 L12 16 L2 20 Z",
                  fill: "none",
                  stroke: o,
                  strokeWidth: f,
                  style: {
                    filter: e !== "offline" ? `drop-shadow(0 0 4px ${i})` : "none"
                  }
                }
              ),
              /* @__PURE__ */ c(
                "path",
                {
                  d: "M12 5 L19 18 L12 15 L5 18 Z",
                  fill: o,
                  opacity: 0.3
                }
              ),
              /* @__PURE__ */ c(
                "circle",
                {
                  cx: "12",
                  cy: "12",
                  r: s / 4,
                  fill: o,
                  style: {
                    filter: e !== "offline" ? `drop-shadow(0 0 6px ${i})` : "none"
                  },
                  children: n && e === "online" && /* @__PURE__ */ c(
                    "animate",
                    {
                      attributeName: "opacity",
                      values: "1;0.5;1",
                      dur: "2s",
                      repeatCount: "indefinite"
                    }
                  )
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Gn = {
  idle: {
    color: "#00FF88",
    label: "READY",
    icon: "◉",
    animated: !1
  },
  transmitting: {
    color: "#00D4FF",
    label: "TRANSMITTING",
    icon: "◈",
    animated: !0
  },
  receiving: {
    color: "#9D8CFF",
    label: "RECEIVING",
    icon: "◈",
    animated: !0
  },
  error: {
    color: "#FF6B6B",
    label: "ERROR",
    icon: "◇",
    animated: !1
  }
}, tr = ({
  state: e = "idle",
  message: t,
  size: n = "md",
  className: r
}) => {
  const a = Gn[e], o = n === "sm";
  return /* @__PURE__ */ z(
    "div",
    {
      className: m(
        "flex items-center gap-2",
        r
      ),
      children: [
        /* @__PURE__ */ c(
          "div",
          {
            className: m(
              "flex items-center justify-center rounded-full",
              a.animated && "animate-pulse"
            ),
            style: {
              width: o ? 6 : 8,
              height: o ? 6 : 8,
              background: a.color,
              boxShadow: `0 0 ${o ? 4 : 8}px ${a.color}`
            }
          }
        ),
        /* @__PURE__ */ c(
          "span",
          {
            style: {
              fontSize: o ? 8 : 10,
              fontWeight: 700,
              letterSpacing: o ? "1px" : "1.5px",
              color: a.color,
              textTransform: "uppercase"
            },
            children: t || a.label
          }
        ),
        a.animated && /* @__PURE__ */ c("div", { className: "flex items-center gap-0.5 ml-1", children: [0, 1, 2].map((i) => /* @__PURE__ */ c(
          "div",
          {
            className: "animate-pulse",
            style: {
              width: 2,
              height: o ? 8 : 12,
              background: a.color,
              borderRadius: 1,
              animationDelay: `${i * 0.15}s`,
              animationDuration: "0.6s"
            }
          },
          i
        )) })
      ]
    }
  );
};
function Tn({ size: e = 120, className: t = "" }) {
  const [n, r] = ie(!1);
  return te(() => {
    const a = setTimeout(() => r(!0), 100);
    return () => clearTimeout(a);
  }, []), /* @__PURE__ */ z(
    "div",
    {
      className: m("holographic-logo-container", t),
      style: {
        width: e,
        height: e,
        opacity: n ? 1 : 0,
        transform: n ? "scale(1)" : "scale(0.8)",
        transition: "all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)"
      },
      children: [
        /* @__PURE__ */ c("div", { className: "logo-glow-ring" }),
        /* @__PURE__ */ z(
          "svg",
          {
            viewBox: "0 0 100 100",
            width: e,
            height: e,
            className: "holographic-logo-svg",
            children: [
              /* @__PURE__ */ z("defs", { children: [
                /* @__PURE__ */ z("linearGradient", { id: "holoGradient", x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
                  /* @__PURE__ */ c("stop", { offset: "0%", stopColor: "#00D4FF", stopOpacity: "1", children: /* @__PURE__ */ c(
                    "animate",
                    {
                      attributeName: "stop-color",
                      values: "#00D4FF;#7B68EE;#00D4FF",
                      dur: "4s",
                      repeatCount: "indefinite"
                    }
                  ) }),
                  /* @__PURE__ */ c("stop", { offset: "50%", stopColor: "#7B68EE", stopOpacity: "1", children: /* @__PURE__ */ c(
                    "animate",
                    {
                      attributeName: "stop-color",
                      values: "#7B68EE;#00D4FF;#7B68EE",
                      dur: "4s",
                      repeatCount: "indefinite"
                    }
                  ) }),
                  /* @__PURE__ */ c("stop", { offset: "100%", stopColor: "#00D4FF", stopOpacity: "1", children: /* @__PURE__ */ c(
                    "animate",
                    {
                      attributeName: "stop-color",
                      values: "#00D4FF;#7B68EE;#00D4FF",
                      dur: "4s",
                      repeatCount: "indefinite"
                    }
                  ) })
                ] }),
                /* @__PURE__ */ z("filter", { id: "holoGlow", x: "-50%", y: "-50%", width: "200%", height: "200%", children: [
                  /* @__PURE__ */ c("feGaussianBlur", { stdDeviation: "2", result: "coloredBlur" }),
                  /* @__PURE__ */ z("feMerge", { children: [
                    /* @__PURE__ */ c("feMergeNode", { in: "coloredBlur" }),
                    /* @__PURE__ */ c("feMergeNode", { in: "SourceGraphic" })
                  ] })
                ] }),
                /* @__PURE__ */ c("pattern", { id: "scanLines", patternUnits: "userSpaceOnUse", width: "100", height: "4", children: /* @__PURE__ */ c("line", { x1: "0", y1: "0", x2: "100", y2: "0", stroke: "rgba(0, 212, 255, 0.1)", strokeWidth: "1" }) })
              ] }),
              /* @__PURE__ */ c(
                "circle",
                {
                  cx: "50",
                  cy: "50",
                  r: "45",
                  fill: "rgba(0, 20, 40, 0.6)",
                  stroke: "url(#holoGradient)",
                  strokeWidth: "1.5",
                  filter: "url(#holoGlow)",
                  children: /* @__PURE__ */ c(
                    "animate",
                    {
                      attributeName: "r",
                      values: "44;46;44",
                      dur: "3s",
                      repeatCount: "indefinite"
                    }
                  )
                }
              ),
              /* @__PURE__ */ z("g", { filter: "url(#holoGlow)", children: [
                /* @__PURE__ */ c(
                  "path",
                  {
                    d: "M50 15 L75 70 L50 60 L25 70 Z",
                    fill: "none",
                    stroke: "url(#holoGradient)",
                    strokeWidth: "2",
                    strokeLinejoin: "round"
                  }
                ),
                /* @__PURE__ */ c(
                  "path",
                  {
                    d: "M50 22 L70 62 L50 54 L30 62 Z",
                    fill: "url(#holoGradient)",
                    opacity: "0.3"
                  }
                ),
                /* @__PURE__ */ c(
                  "text",
                  {
                    x: "50",
                    y: "52",
                    textAnchor: "middle",
                    fontSize: "16",
                    fontWeight: "700",
                    fontFamily: "'Geist', 'SF Pro Display', sans-serif",
                    fill: "url(#holoGradient)",
                    letterSpacing: "2",
                    children: "EP"
                  }
                )
              ] }),
              /* @__PURE__ */ c(
                "rect",
                {
                  x: "5",
                  y: "5",
                  width: "90",
                  height: "90",
                  rx: "45",
                  fill: "url(#scanLines)",
                  opacity: "0.5",
                  className: "scan-line-overlay"
                }
              ),
              /* @__PURE__ */ z(
                "rect",
                {
                  x: "5",
                  y: "0",
                  width: "90",
                  height: "3",
                  fill: "rgba(0, 212, 255, 0.4)",
                  rx: "1",
                  children: [
                    /* @__PURE__ */ c(
                      "animate",
                      {
                        attributeName: "y",
                        values: "5;95;5",
                        dur: "3s",
                        repeatCount: "indefinite"
                      }
                    ),
                    /* @__PURE__ */ c(
                      "animate",
                      {
                        attributeName: "opacity",
                        values: "0.4;0.1;0.4",
                        dur: "3s",
                        repeatCount: "indefinite"
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c("div", { className: "holographic-flicker" }),
        /* @__PURE__ */ c("style", { children: `
        .holographic-logo-container {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .logo-glow-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0, 212, 255, 0.2) 0%, transparent 70%);
          animation: pulse-glow 3s ease-in-out infinite;
        }

        .holographic-logo-svg {
          position: relative;
          z-index: 1;
        }

        .holographic-flicker {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: linear-gradient(
            180deg,
            transparent 0%,
            rgba(0, 212, 255, 0.03) 50%,
            transparent 100%
          );
          animation: flicker 0.15s infinite;
          pointer-events: none;
        }

        @keyframes pulse-glow {
          0%, 100% {
            transform: scale(1);
            opacity: 0.6;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.8;
          }
        }

        @keyframes flicker {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.97;
          }
        }

        .scan-line-overlay {
          animation: scan-drift 10s linear infinite;
        }

        @keyframes scan-drift {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(4px);
          }
        }
      ` })
      ]
    }
  );
}
Tn.displayName = "HolographicLogo";
function Wn({ size: e = 28, className: t = "" }) {
  return /* @__PURE__ */ z(
    "svg",
    {
      viewBox: "0 0 100 100",
      width: e,
      height: e,
      className: m("mini-logo", t),
      children: [
        /* @__PURE__ */ z("defs", { children: [
          /* @__PURE__ */ z("linearGradient", { id: "miniLogoGradient", x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
            /* @__PURE__ */ c("stop", { offset: "0%", stopColor: "#00D4FF" }),
            /* @__PURE__ */ c("stop", { offset: "100%", stopColor: "#7B68EE" })
          ] }),
          /* @__PURE__ */ z("filter", { id: "miniLogoGlow", x: "-50%", y: "-50%", width: "200%", height: "200%", children: [
            /* @__PURE__ */ c("feGaussianBlur", { stdDeviation: "2", result: "coloredBlur" }),
            /* @__PURE__ */ z("feMerge", { children: [
              /* @__PURE__ */ c("feMergeNode", { in: "coloredBlur" }),
              /* @__PURE__ */ c("feMergeNode", { in: "SourceGraphic" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "50",
            cy: "50",
            r: "45",
            fill: "rgba(0, 20, 40, 0.6)",
            stroke: "url(#miniLogoGradient)",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ z("g", { filter: "url(#miniLogoGlow)", children: [
          /* @__PURE__ */ c(
            "path",
            {
              d: "M50 18 L72 65 L50 55 L28 65 Z",
              fill: "url(#miniLogoGradient)",
              opacity: "0.3"
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              d: "M50 18 L72 65 L50 55 L28 65 Z",
              fill: "none",
              stroke: "url(#miniLogoGradient)",
              strokeWidth: "2.5",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ c(
            "text",
            {
              x: "50",
              y: "52",
              textAnchor: "middle",
              fontSize: "14",
              fontWeight: "700",
              fontFamily: "'Geist', sans-serif",
              fill: "url(#miniLogoGradient)",
              letterSpacing: "1",
              children: "EP"
            }
          )
        ] })
      ]
    }
  );
}
Wn.displayName = "MiniLogo";
const On = {
  base: "vs-dark",
  inherit: !0,
  rules: [
    // Base
    { token: "", foreground: "E8F4F8", background: "0a0e1a" },
    // Comments
    { token: "comment", foreground: "5a6a7a", fontStyle: "italic" },
    { token: "comment.doc", foreground: "6a7a8a" },
    // Strings
    { token: "string", foreground: "00FF88" },
    { token: "string.escape", foreground: "FFB347" },
    { token: "string.regexp", foreground: "FF6B35" },
    // Numbers & Constants
    { token: "number", foreground: "FFB347" },
    { token: "constant", foreground: "FFB347" },
    { token: "constant.language", foreground: "7B68EE" },
    { token: "constant.numeric", foreground: "FFB347" },
    // Keywords
    { token: "keyword", foreground: "00D4FF", fontStyle: "bold" },
    { token: "keyword.control", foreground: "00D4FF" },
    { token: "keyword.operator", foreground: "00D4FF" },
    // Types
    { token: "type", foreground: "7B68EE" },
    { token: "type.identifier", foreground: "7B68EE" },
    { token: "class", foreground: "7B68EE" },
    { token: "interface", foreground: "7B68EE" },
    // Functions
    { token: "function", foreground: "00D4FF" },
    { token: "function.declaration", foreground: "00D4FF" },
    { token: "method", foreground: "00D4FF" },
    // Variables
    { token: "variable", foreground: "E8F4F8" },
    { token: "variable.parameter", foreground: "E8F4F8" },
    { token: "variable.other", foreground: "E8F4F8" },
    // Operators & Punctuation
    { token: "operator", foreground: "00D4FF" },
    { token: "delimiter", foreground: "6a7a8a" },
    { token: "delimiter.bracket", foreground: "7B68EE" },
    // Tags (HTML/JSX)
    { token: "tag", foreground: "00D4FF" },
    { token: "tag.attribute.name", foreground: "7B68EE" },
    { token: "tag.attribute.value", foreground: "00FF88" },
    // Markdown
    { token: "markup.heading", foreground: "00D4FF", fontStyle: "bold" },
    { token: "markup.bold", fontStyle: "bold" },
    { token: "markup.italic", fontStyle: "italic" },
    { token: "markup.underline", fontStyle: "underline" },
    { token: "markup.quote", foreground: "5a6a7a", fontStyle: "italic" },
    { token: "markup.list", foreground: "FFB347" },
    { token: "markup.raw", foreground: "00FF88" },
    { token: "markup.link", foreground: "7B68EE" },
    // JSON
    { token: "string.key.json", foreground: "00D4FF" },
    { token: "string.value.json", foreground: "00FF88" },
    // YAML
    { token: "type.yaml", foreground: "00D4FF" },
    { token: "string.yaml", foreground: "00FF88" }
  ],
  colors: {
    // Editor background
    "editor.background": "#0a0e1a",
    "editor.foreground": "#E8F4F8",
    // Selection
    "editor.selectionBackground": "#00D4FF33",
    "editor.selectionHighlightBackground": "#00D4FF22",
    "editor.inactiveSelectionBackground": "#00D4FF1a",
    // Line highlighting
    "editor.lineHighlightBackground": "#00D4FF0a",
    "editor.lineHighlightBorder": "#00D4FF20",
    // Cursor
    "editorCursor.foreground": "#00D4FF",
    "editorCursor.background": "#0a0e1a",
    // Line numbers
    "editorLineNumber.foreground": "#3a4a5a",
    "editorLineNumber.activeForeground": "#00D4FF",
    // Gutter
    "editorGutter.background": "#0a0e1a",
    "editorGutter.modifiedBackground": "#7B68EE",
    "editorGutter.addedBackground": "#00FF88",
    "editorGutter.deletedBackground": "#FF4B4B",
    // Indent guides
    "editorIndentGuide.background": "#1a2a3a",
    "editorIndentGuide.activeBackground": "#00D4FF40",
    // Brackets
    "editorBracketMatch.background": "#00D4FF20",
    "editorBracketMatch.border": "#00D4FF",
    // Find/Replace
    "editor.findMatchBackground": "#00D4FF40",
    "editor.findMatchHighlightBackground": "#00D4FF20",
    // Minimap
    "minimap.background": "#050508",
    "minimapSlider.background": "#00D4FF20",
    "minimapSlider.hoverBackground": "#00D4FF30",
    "minimapSlider.activeBackground": "#00D4FF40",
    // Scrollbar
    "scrollbar.shadow": "#00000050",
    "scrollbarSlider.background": "#00D4FF30",
    "scrollbarSlider.hoverBackground": "#00D4FF50",
    "scrollbarSlider.activeBackground": "#00D4FF70",
    // Widgets
    "editorWidget.background": "#0d1526",
    "editorWidget.border": "#00D4FF40",
    "editorSuggestWidget.background": "#0d1526",
    "editorSuggestWidget.border": "#00D4FF40",
    "editorSuggestWidget.selectedBackground": "#00D4FF30",
    "editorSuggestWidget.highlightForeground": "#00D4FF",
    // Hover
    "editorHoverWidget.background": "#0d1526",
    "editorHoverWidget.border": "#00D4FF40",
    // Error/Warning
    "editorError.foreground": "#FF4B4B",
    "editorWarning.foreground": "#FFB347",
    "editorInfo.foreground": "#00D4FF",
    // Overview ruler
    "editorOverviewRuler.border": "#00D4FF20",
    "editorOverviewRuler.errorForeground": "#FF4B4B",
    "editorOverviewRuler.warningForeground": "#FFB347",
    "editorOverviewRuler.infoForeground": "#00D4FF"
  }
};
function nr(e) {
  e.editor.defineTheme("holomatrix", On);
}
const rr = "holomatrix";
export {
  jt as Badge,
  Gt as Button,
  er as CommBadge,
  Ut as CommandBar,
  Qn as DeckIndicator,
  Nn as GridOverlay,
  rr as HOLOMATRIX_THEME_NAME,
  Tn as HolographicLogo,
  Tt as Input,
  qn as LCARSBar,
  Yn as LCARSButton,
  Jn as LCARSList,
  Zn as LCARSListItem,
  Xn as LCARSPanel,
  Wn as MiniLogo,
  Sn as Pane,
  Wt as Panel,
  Ot as PanelHeader,
  zn as ResizeHandle,
  _n as ScanLine,
  Cn as Shimmer,
  wn as SplitPane,
  kn as StarfieldBackground,
  Kt as StatusBar,
  dt as StatusLight,
  tr as TransmissionStatus,
  m as cn,
  Vn as formatStardate,
  Vt as getCurrentStardate,
  Kn as getStardateTime,
  On as holomatrixTheme,
  nr as registerHolomatrixTheme,
  ut as toStardate
};
